import React from 'react';

import { Grid, Stack } from '@mui/material';

import { PillsContainer } from './ContentPill';
import InfoCard from './InfoCard';
import PreferenceCard from './PreferenceCard';
import { getCategoryIcon, getPillIcon } from '../utils/iconMapping';

interface DynamicContentRendererProps {
  category: string;
  title: string;
  items: Array<{
    id: string;
    label: string;
    value: string;
    subtitle?: string | null;
    variant?: 'default' | 'highlighted' | 'editable';
    showEditIcon?: boolean;
  }>;
  layout?: 'grid' | 'list';
  columns?: number;
  fieldType?: 'dropdown' | 'checkbox' | 'tags' | 'textarea' | 'geo_state';
  slug?: string | null;
}

const DynamicContentRenderer: React.FC<DynamicContentRendererProps> = ({
  category,
  title,
  items,
  layout = 'grid',
  columns = 2,
  fieldType = 'dropdown',
  slug,
}) => {
  /*  console.log('[DynamicContentRenderer] Category:', category);
  console.log('[DynamicContentRenderer] Title:', title);
  console.log('[DynamicContentRenderer] Items:', items);
  console.log('[DynamicContentRenderer] Layout:', layout);
  console.log('[DynamicContentRenderer] Columns:', columns);
  console.log('[DynamicContentRenderer] Field Type:', fieldType); */

  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '_');

  if (fieldType === 'dropdown') {
    if (layout !== 'grid') {
      return (
        <Grid container spacing={1}>
          {items.map(item => (
            <Grid item xs={12} sm={6} md={12 / columns} key={item.id}>
              <InfoCard
                icon={getPillIcon(item.value)}
                title={item.label}
                value={item.value}
                subtitle={item.subtitle}
                variant={item.variant || 'default'}
                showWizardIcon={item.showEditIcon}
                slug={slug}
              />
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <Stack spacing={1}>
        {items.map(item => (
          <InfoCard
            key={item.id}
            icon={getPillIcon(item.value)}
            title={item.label}
            value={item.value}
            subtitle={item.subtitle}
            variant={item.variant || 'default'}
            showWizardIcon={item.showEditIcon}
            slug={slug}
          />
        ))}
      </Stack>
    );
  }

  if (fieldType === 'checkbox') {
    const pills = items.map(item => ({
      icon: getPillIcon(item.value),
      text: item.value,
      variant: (item.variant === 'highlighted' ? 'filled' : 'outlined') as
        | 'default'
        | 'outlined'
        | 'filled',
      showWizard: item.showEditIcon,
    }));

    return (
      <PreferenceCard icon={getCategoryIcon(normalizedCategory)} title={title}>
        <PillsContainer
          pills={pills}
          direction={layout === 'list' ? 'column' : 'row'}
          wrap={layout === 'grid'}
        />
      </PreferenceCard>
    );
  }

  if (fieldType === 'tags') {
    if (layout !== 'grid') {
      return (
        <Grid container spacing={1}>
          {items.map(item => (
            <Grid item xs={12} sm={6} md={12 / columns} key={item.id}>
              <InfoCard
                icon={getPillIcon(item.value)}
                title={item.label}
                value={item.value}
                subtitle={item.subtitle}
                variant={item.variant || 'default'}
                showWizardIcon={item.showEditIcon}
                slug={slug}
              />
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <Stack spacing={1}>
        {items.map(item => (
          <InfoCard
            key={item.id}
            icon={getPillIcon(item.value)}
            title={item.label}
            value={item.value}
            subtitle={item.subtitle}
            variant={item.variant || 'default'}
            showWizardIcon={item.showEditIcon}
            slug={slug}
          />
        ))}
      </Stack>
    );
  }

  if (fieldType === 'textarea' || fieldType === 'geo_state') {
    if (layout !== 'grid') {
      return (
        <Grid container spacing={1}>
          {items.map(item => (
            <Grid item xs={12} sm={6} md={12 / columns} key={item.id}>
              <InfoCard
                icon={getPillIcon(item.value)}
                title={item.label}
                value={item.value}
                subtitle={item.subtitle ?? ''}
                variant={item.variant || 'default'}
                showWizardIcon={item.showEditIcon}
                slug={slug}
              />
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <Stack spacing={1}>
        {items.map(item => (
          <InfoCard
            key={item.id}
            icon={getPillIcon(item.value)}
            title={item.label}
            value={item.value}
            subtitle={item.subtitle}
            variant={item.variant || 'default'}
            showWizardIcon={item.showEditIcon}
            slug={slug}
          />
        ))}
      </Stack>
    );
  }

  // Fallback para tipos não mapeados
  return (
    <div>
      <h3>{title}</h3>
      <ul>
        {items.map(item => (
          <li key={item.id}>{item.value}</li>
        ))}
      </ul>
    </div>
  );
};

export default DynamicContentRenderer;
